import React from 'react';
import PropTypes from 'prop-types';
import ImageSvg from '../image/ImageSvg';
import modal from '../../../legacy/app/modal';
import popup from '../../../legacy/app/popup';

import likeIcon from '../../../../../assets/img/svg/png/like.png';
import dislikeIcon from '../../../../../assets/img/svg/png/nebus.png';

// TODO
const VoteButtons = (props) => {
  const {
    onVote,
    includeSkip,
    active,
    noShadow,
    noAboLimitReached,
  } = props;

  let mainClasses = 'matches-votes btnGroupLarge--horizontal';
  if (includeSkip) {
    mainClasses += ' matches-votes--includeSkip';
  }
  if (noShadow) {
    mainClasses += ' matches-votes--noShadow';
  }

  const handleVote = (vote, e) => {
    if (active !== vote) {
      if (noAboLimitReached) {
        e.currentTarget.blur();
        // popup.subscriptionMessage();
        popup.featureMessage('unlimited_matches_votes');
        return;
      }

      onVote(vote);
      e.currentTarget.blur();
      return;
    }

    modal.confirm('Vai tiešām atcelt šo izvēli?', (result) => {
      if (result) {
        onVote(vote);
      }
    });
  };

  return (
    <div>
      <div className={mainClasses}>
        <div
          className={`btn dislike tac dib${active === 'dislike' ? ' active' : ''}`}
          role="button"
          tabIndex="0"
          onClick={(e) => handleVote('dislike', e)}
          onKeyDown={(e) => handleVote('dislike', e)}
        >
          <div className="btn-vc">
            <span className="dib prs">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <img
                    style={{
                      width: '20px',
                      height: '24px',
                    }}
                    src={dislikeIcon}
                    alt="like"
                  />
                </span>
              </span>
            </span>
            <span className="btn-text">Nē, nebūs!</span>
          </div>
        </div>
        <div className="btnGroupLarge-line--vertical dib" />
        <div
          className={`btn like dib${active === 'like' ? ' active' : ''}`}
          role="button"
          tabIndex="0"
          onClick={(e) => handleVote('like', e)}
          onKeyDown={(e) => handleVote('like', e)}
        >
          <div className="btn-vc">
            <span className="dib prs">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <img
                    style={{
                      width: '20px',
                      height: '24px',
                    }}
                    src={likeIcon}
                    alt="like"
                  />
                </span>
              </span>
            </span>
            <span className="btn-text">Man Patīk!</span>
          </div>
        </div>
      </div>
      {includeSkip && (
        <div
          className="skip pr tac tcb mtm tss"
          role="button"
          tabIndex="0"
          onClick={(e) => handleVote('skip', e)}
          onKeyDown={(e) => handleVote('skip', e)}
        >
          <span className="btn-text">
            Izlaist, rādīt nākošo
            <span className="mls dib">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <ImageSvg
                    svg="icon-arrowrightlight"
                    iconClass="icon--arrowRightLight icon--blue tss"
                  />
                </span>
              </span>
            </span>
          </span>
        </div>
      )}
    </div>
  );
};

VoteButtons.propTypes = {
  onVote: PropTypes.func.isRequired,
  includeSkip: PropTypes.bool,
  active: PropTypes.string,
  noShadow: PropTypes.bool,
  noAboLimitReached: PropTypes.bool,
};

VoteButtons.defaultProps = {
  includeSkip: false,
  active: null,
  noShadow: false,
  noAboLimitReached: false,
};

export default VoteButtons;
